<!--已关闭  -->
<template>
  <div class="closedIndent">
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check ='false'
          :offset="20"
          v-if="isData"
          @load="onLoad">
        <div class="card" v-for="(item,index) in closeList" :key="index">
          <div class="card-header">
            <div class="card-header-first">
              <div class="left">{{filtersStatus(item.status)}}</div>
              <div class="right">
                <p class="count">{{item.cancelType==1?'超时未支付':item.cancelType==2?'主动取消':'客服取消'}}</p>
              </div>
            </div>
          </div>
          <div class="card-body" @click="courseDetails(item.orderNo)">
            <div class="public" v-for="(course,index) in item.orderPackageProductRespList||item.orderProductList" :key="index">
              <div class="text"><p class="name"><i v-if="course.productName.substr(0,1)=='【'" class="title-special-processing"/>{{course.productName}}</p></div>
              <span class="pice">￥{{course.productPrice}}</span>
            </div>
            <!-- <div class="public">
              <div class="text">
                <span>协议</span>
                <p class="deal">
                考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                </p>
              </div>
              <span class="pice">￥2000</span>
            </div> -->
            <!-- <div class="public">
              <div class="text">
                <span>增值</span>
                <p class="deal">
                  考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                  </p>
                </div>
              <span class="pice">￥2000</span>
          </div> -->
          </div>
          <div class="card-footer">
            <div class="pay">
              <span>下单时间  {{item.createTime}}</span>
              <div class="money">
              <span><p>{{filtersPayText(item.status)}}</p><p class="pice">￥{{item.channel==45?0:item.partnerOrder?item.orderTotalAmount:item.orderAmount}}</p></span>
              </div>
            </div>
          </div>
        </div>
        </van-list>
        <EmptyData :emptyName="'noIndent'" v-else/>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { reqOrderList } from '@/api/personal/orderController';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { orderType, selectPayText } from '../indentTools';

export default {
  data() {
    return {
      orderParam: {
        pageNum: 1,
        pageSize: 5,
        status: '4',
      },
      closeList: [],
      closeTotal: 0,
      loading: true,
      finished: false,
      refreshing: false,
      isData: true,
    };
  },

  components: {
    EmptyData,
  },

  computed: {},

  mounted() {},

  created() {
    this.getCloseList(this.orderParam);
  },

  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.closeList.length >= this.closeTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.orderParam.pageNum += 1;
        this.getCloseList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.refreshing = true;
      this.orderParam.pageNum = 1;
      this.getCloseList(this.orderParam);
    },
    // 请求数据
    async getCloseList(data) {
      try {
        const res = await reqOrderList(data);
        if (res.code === 0) {
          if (this.refreshing) {
            this.closeList = [];
          }
          if (res.data.total === 0) {
            this.isData = false;
          }
          this.refreshing = false;
          this.loading = false;
          res.data.data.forEach((item) => {
            const { orderPackageProductRespList } = item;
            (orderPackageProductRespList || []).forEach((child) => {
              Object.assign(child, { productName: child.packageName, productPrice: child.price });
            });
          });
          this.closeList.push(...res.data.data);
          this.closeTotal = res.data.total;
        } else {
          this.$toast(`请求异常！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.mmessage);
      }
    },
    // 订单状态
    filtersStatus(status) {
      return orderType(status);
    },
    filtersPayText(status) {
      return selectPayText(status);
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
  },
};

</script>
<style lang="scss" scoped>
@import '@/style/indentCard.scss';
.closedIndent{
  height: 100%;
}
</style>
